"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MGMAuthError = exports.IdentityError = exports.ApiErrors = exports.KNOWN_ERROR_CODES = exports.UNKNOWN_ERROR_MESSAGE = void 0;
exports.UNKNOWN_ERROR_MESSAGE = 'Oops! We have encountered an unknown error, please contact support.';
exports.KNOWN_ERROR_CODES = {
    E001: 'Internal server error',
    E002: 'Account already exists',
    E003: 'Users must be at least 21 years old',
    E004: 'Required field is missing',
    E005: "We're sorry, but that account wasn't found. Please check your information and try again.",
    E006: "We're sorry, but there's no email currently associated with your MGM Rewards profile. Please contact MGM Resorts Member Services at 866.761.7111 for further assistance.",
    E007: "We're sorry, but the information entered doesn't match an existing profile. Please check your information and try again.",
    E008: "We're sorry, but the code you entered does not match. Please check your information and try again. ",
    E009: "We're sorry, but the provided date of birth doesn't match our records. Please check your information and try again.",
    E010: "We've found multiple profiles associated with your account. Please contact MGM Resorts Member Services at 866.761.7111 for further assistance.",
    E011: "We're sorry, but we're unable to update your account, as the last name on your Hyatt profile does not match that of your MGM Rewards profile. Please contact MGM Resorts Member Services at 866.761.7111 for further assistance.",
    E012: "We're sorry, but were unable to update your account (system error). Please contact MGM Rewards Member Services at 866.761.7111 for further assistance.",
    E013: "We're sorry, but one of the fields you tried to update cannot be modified. Please review your information and try again.",
    E014: "We're sorry, but an error has occurred and your profile has not been updated. Please try again or contact MGM Resorts Member Services at 866.761.7111 for further assistance.",
    E015: "We're sorry, but this account is locked. Please contact MGM Resorts Member Services at 866.761.7111 for further assistance.",
    E016: "We're sorry, but your Okta profile was not found. Please check your information and try again.",
    E017: "We're sorry, but we were unable to verify that activation code. Please check your information and try again.",
    E018: "We're sorry, but there was an error accessing your account. Please contact MGM Resorts Member Services at 866.761.7111 for further assistance.",
    E019: "We're sorry, but the password provided does not match. Please check your information and try again.",
    E20: "We're sorry, but this Hyatt profile is already linked to an account and cannot be registered again.",
    E21: "We're sorry, but this Hyatt profile is already linked to a different account and cannot be registered again.",
    E22: "We're sorry, but this Hyatt profile is already linked to a different account and cannot be registered again.",
    E23: "We're sorry, but this MGM Rewards account was activated under another email address. Please log in using that email or contact MGM Resorts Member Services at 866.761.7111 for further assistance.",
    E0000004: 'Failed to authenticate, check your email and password and try again',
    E0000004_bet_mgm: "Sorry, you have entered invalid credentials. Please try again or <a href='{REDIRECT_URI}'>register manually through BetMGM.</a>",
    E0000080: 'Password cannot be your current password',
};
exports.ApiErrors = {
    stopCode: {
        errorCode: 'E015',
        message: exports.KNOWN_ERROR_CODES.E015,
    },
    authenticationFailed: {
        errorCode: 'E0000004',
        message: exports.KNOWN_ERROR_CODES.E0000004,
        betmgmMessage: exports.KNOWN_ERROR_CODES.E0000004_bet_mgm,
    },
};
class IdentityError extends Error {
    constructor(message, code) {
        super(message);
        this.code = code;
    }
}
exports.IdentityError = IdentityError;
class MGMAuthError extends Error {
    constructor(options) {
        var _a;
        super(options.message);
        this.name = (_a = options.name) !== null && _a !== void 0 ? _a : this.constructor.name;
        this.transaction = options.transaction;
        if (options.stack) {
            this.stack = options.stack;
        }
    }
}
exports.MGMAuthError = MGMAuthError;
